/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycChangeRequestWithItemsDto } from '../../models/kyc-change-request-with-items-dto';

export interface GetAllWithItems$Params {
  processId: string;
}

export function getAllWithItems(http: HttpClient, rootUrl: string, params: GetAllWithItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KycChangeRequestWithItemsDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllWithItems.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KycChangeRequestWithItemsDto>>;
    })
  );
}

getAllWithItems.PATH = '/kyc/processes/{processId}/change-requests';
